import { usePageStore } from "@/store/usePageStore";
import { useMemo } from "react";

export function usePopFromPrefiltredProj() {
  const isPresentationMode = usePageStore((state) => state.isPresentationMode);
  const previousVisitedPath = usePageStore((state) => state.previousVisitedPath);
  const previousPopPath = usePageStore((state) => state.previousPopPath);
  const isLastPopBackwards = usePageStore((state) => state.isLastPopBackwards);
	const isPreviousPopPathFromRelated = previousPopPath?.includes('origin=related');

  const isPopFromPrefiltredProj = useMemo(() => {
    return (
      !isPresentationMode &&
      previousPopPath === previousVisitedPath &&
      isPreviousPopPathFromRelated &&
      isLastPopBackwards
    );
  }, [
    isPresentationMode,
    previousPopPath,
    previousVisitedPath,
    isPreviousPopPathFromRelated,
    isLastPopBackwards,
  ]);

  return isPopFromPrefiltredProj;
}